import api from '../../api'
import router from "../../router";
import {disposeResult} from '../../util/DisposeResult'
import {downFile} from '../../util/DownFile'

export default {
  name: 'reader',

  data() {
    return {
      data: [],
      checkStatus: '0',
      options: [{
        value: '0',
        label: '未审核',
      }, {
        value: '1',
        label: '已审核',
      }, {
        value: '2',
        label: '全部'
      }],
      verdictOptions: [{
        value: "APPROVED",
        label: "建议通过",
      }, {
        value: "REFUSED",
        label: "建议不通过",
      }],
      oneColumn: false,
      twoColumn: false,
      threeColumn: false,
      dialogTitle: "",//弹出框的标题
      remarkDialog: false,
      remarkForm: {
        remark: "",//评语
        verdict: "",//结论
        approvalGrade: "NOT_APPLICABLE",//评级
      },
      remarkRules: {
        remark: [
          {required: true, message: '请填写评语', trigger: 'submit'},
        ],
        verdict: [
          {required: true, message: '请选择结论', trigger: 'submit'},
        ]
      },
      currentRow: {},
      isActive: false,//打开大文件时间较长给个遮罩
      remarkDisabled: false,//审核员审核之后就不能修改
      educationList:[
        {
          value: 'NOT_APPLICABLE',
          label: '全部'
        }, {
          value: 'UNDERGRADE',
          label: '本科生'
        }, {
          value: 'MASTER',
          label: '研究生'
        },
      ],
      teamGrade: 'NOT_APPLICABLE',//学历筛选条件
      approvalGradeList:[
        {
          value:'NOT_APPLICABLE',
          label:'全部',
        },
        {
          value: 'GRADE_A',
          label: '通过A'
        }, {
          value: 'GRADE_B',
          label: '通过B'
        }, {
          value: 'GRADE_C',
          label: '通过C'
        }, {
          value: 'GRADE_D',
          label: '通过D'
        }
      ],//评级情况列表
      gradeStatus:'NOT_APPLICABLE',//当前评级情况的筛选条件
      showApprovalGrade:false,//是否展示评级情况
      tableLoading:false,//表格loading
      buttonLoading:false,//按钮loading
      curRound:null,//当前阶段
    }
  },

  methods: {

    /**
     * 当筛选条件发生变化时
     */
    onchange() {
      if(this.checkStatus=='1' && this.$store.state.curRound == 3){
        this.showApprovalGrade = true
      }else{
        this.showApprovalGrade = false
      }
      if (this.checkStatus === "0") {//未审核
        this.getNotRefereedByRefereeIdAndRoundNo()
      } else if (this.checkStatus === "1") {//已审核
        this.getRefereedByRefereeIdAndRoundNo()
        this.showApprovalGrade = this.$store.state.curRound == 3 ? true :false
      } else if (this.checkStatus === '2') {//全部
        this.getAllByRefereeIdAndRoundNo()
      }
    },

    /**
     * 查看论文信息
     * @param row
     */
    viewWordData(row) {
      this.currentRow = row
      let number = router.app.$options.store.state.curRound
      let id = ""
      let fileName = row.teamName+"-"
      switch (number) {
        case 1:
          id = row.abstractFileName//1阶段
          fileName+=row.abstractOriginalName
          break
        case 2:
          id = row.briefFileName//2阶段
          fileName+=row.briefOriginalName
          break
        case 3:
          id = row.bodyFileName//三阶段
          fileName+=row.bodyOriginalName
          break
      }
      this.isActive = true
      let vue = this
      api.contribute.getWorksOfManager(id).then(function (response) {
        if (response == null) {
          return null
        }
        downFile(response,fileName,vue)
      })
    },

    /**
     * 审稿
     * @param row
     */
    addRemark(row) {
      this.currentRow = row
      this.remarkForm.remark = ""
      this.remarkForm.verdict = ""
      this.remarkForm.approvalGrade = "NOT_APPLICABLE"
      if (row.refereeOpinionVos[0].refereeStatusEnum === "REFUSED" || row.refereeOpinionVos[0].refereeStatusEnum === "APPROVED") {
        this.remarkForm.remark = row.refereeOpinionVos[0].refereeOpinionInfo
        this.remarkForm.verdict = row.refereeOpinionVos[0].refereeStatusEnum
        this.remarkDisabled = true
      } else {
        this.remarkDisabled = false
      }

      this.remarkDialog = true
    },

    /**
     * 保存评语
     */
    saveRemark(formName) {
      let vue = this
      let refereeOpinionInfo = this.remarkForm.remark
      let thesisId = this.currentRow.id
      let refereeStatusEnum = this.remarkForm.verdict
      let approvalGradeEnum = this.curRound===3 ? this.remarkForm.approvalGrade : 'NOT_APPLICABLE'
      this.$refs[formName].validate((valid) => {
          if (valid) {
            // 终稿阶段时传 评级 参数
            vue.buttonLoading = true
            api.contribute.giveRefereeOpinion(thesisId, refereeOpinionInfo, refereeStatusEnum, approvalGradeEnum).then(function (response) {
              vue.buttonLoading = false
              if (response == null) {
                return null
              }
              if (response.data.code === "0") {
                vue.remarkDialog = false
                for (let i = 0; i < vue.data.length; i++) {
                  if (vue.data[i].id === thesisId) {
                    vue.data.splice(i, 1)
                    break
                  }
                }
              }
            }).catch(err=>{
              vue.buttonLoading = false
            })
          }
        }
      );
    },

    /**
     * 审稿人查询分配给自己的当前轮数的没有作出批复的作品
     */
    getNotRefereedByRefereeIdAndRoundNo() {
      let vue = this
      this.tableLoading = true
      api.contribute.getNotRefereedByRefereeIdAndRoundNo(this.teamGrade).then(function (response) {
        vue.tableLoading = false
        if (response === null) {
          return null
        }
        if (response.data.code === "0") {
          let result = response.data.result
          vue.data = disposeResult(result, vue)
        }
      }).catch(err=>{
        vue.tableLoading = false
      })
    },

    /**
     * 审稿人查询分配给自己的当前轮数的已经作出批复的作品
     */
    getRefereedByRefereeIdAndRoundNo() {
      let vue = this
      let gradeStatus = this.checkStatus == '1' ? this.gradeStatus : ''
      this.tableLoading = true
      api.contribute.getRefereedByRefereeIdAndRoundNo(this.teamGrade,gradeStatus).then(function (response) {
        vue.tableLoading = false
        if (response === null) {
          return null
        }
        if (response.data.code === "0") {
          let result = response.data.result
          vue.data = disposeResult(result, vue)
        }
      }).catch(err=>{
        vue.tableLoading = false
      })
    },

    /**
     * 审稿人查询自己当前轮数的所有审核作品
     */
    getAllByRefereeIdAndRoundNo() {
      let vue = this
      this.tableLoading = true
      api.contribute.getAllByRefereeIdAndRoundNo(this.teamGrade).then(function (response) {
        vue.tableLoading = false
        if (response === null) {
          return null
        }
        if (response.data.code === "0") {
          let result = response.data.result
          vue.data = disposeResult(result, vue)
        }
      }).catch(err=>{
        vue.tableLoading = false
      })
    },


    /**
     * 隐藏列
     */
    hideColumn() {
      this.oneColumn = false
      this.twoColumn = false
      this.threeColumn = false
    }
  },

  created() {
    //默认查询没有审核的作品
    this.getNotRefereedByRefereeIdAndRoundNo()
    this.curRound = this.$store.state.curRound
  }
}



// WEBPACK FOOTER //
// ./src/js/Reader/Reader.js